import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { useCountry } from '../context/CountryContext';
import { countryLabel } from './CountrySelector';

// Primo avvio dell'app (dominio neutro) con più paesi: conferma del paese del telefono.
export const CountryConfirmDialog = () => {
  const { suggested, countries, setCountry } = useCountry();
  const { t, i18n } = useTranslation();
  const [choosing, setChoosing] = useState(false);
  if (!suggested) return null;
  const lang = (i18n.language || 'it').split('-')[0];
  const guess = countries.find(c => c.code === suggested);
  return (
    <Dialog open onOpenChange={(open) => { if (!open) setCountry(suggested); }}>
      <DialogContent data-testid="country-confirm-dialog" className="max-w-sm">
        <DialogHeader>
          <DialogTitle>{t('countryConfirmTitle')}</DialogTitle>
          <DialogDescription>{t('countryConfirmBody', { country: countryLabel(guess, lang) })}</DialogDescription>
        </DialogHeader>
        {!choosing ? (
          <div className="flex gap-2">
            <Button data-testid="country-confirm-yes" className="flex-1" onClick={() => setCountry(suggested)}>
              {t('countryConfirmYes')}
            </Button>
            <Button data-testid="country-confirm-change" variant="outline" className="flex-1" onClick={() => setChoosing(true)}>
              {t('countryConfirmChange')}
            </Button>
          </div>
        ) : (
          <div className="grid gap-2">
            {countries.map(c => (
              <Button key={c.code} data-testid={`country-pick-${c.code}`} variant="outline" onClick={() => setCountry(c.code)}>
                {countryLabel(c, lang)}
              </Button>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
